module.exports = __webpack_public_path__ + "static/BuddyHelp-dddf0ba69085fb8bbda0af0faa0168e0.jpg";